// import React from 'react'
// import { useLocation, useParams, useNavigate } from 'react-router-dom'
// import { useState } from 'react'
// import { FaArrowLeft, FaArrowRight, FaCoins } from 'react-icons/fa'
// import Navbar from './Navbar'

// const ChapterDetails = () => {
//   const navigate = useNavigate()
//   const { id } = useParams()
//   const location = useLocation()
//   const chapter = location.state?.chapter
//   const previewLength = 500

//   const [showFullContent, setShowFullContent] = useState(false)
//   const content = chapter?.content || 'No content available.'

//   const toggleContent = () => setShowFullContent(!showFullContent)
//   const handleBack = () => navigate(-1)
//   const handleForward = () => navigate(+1)

//   return (
//     <>
//       <Navbar />
//       <div className='container py-4'>
//         <button
//           className='btn text-primary border-0 d-inline-flex align-items-center mb-4'
//           onClick={handleBack}
//         >
//           <FaArrowLeft className='me-2' /> Back
//         </button>
//         {/* <button
//           className='btn text-primary border-0 d-inline-flex align-items-center mb-4'
//           onClick={handleForward}
//         >
//           <FaArrowRight className='me-2' /> Back
//         </button> */}

//         <div className='mb-4'>
//           <h1>Chapter ID: {id}</h1>
//           <h2>{chapter?.chapter_name || 'Chapter Title'}</h2>

//           <div
//             className='bg-light p-4 rounded-3 border border-danger'
//             onCopy={(e) => e.preventDefault()}
//           >
//             <div
//               className='text-muted mb-3'
//               style={{ textAlign: 'justify', userSelect: 'none' }}
//               dangerouslySetInnerHTML={{
//                 __html: showFullContent
//                   ? content
//                   : `${content.substring(0, previewLength)}...`,
//               }}
//             />
//             {content.length > previewLength && (
//               <button
//                 className='btn btn-link text-primary p-0'
//                 onClick={toggleContent}
//                 style={{ textDecoration: 'none' }}
//               >
//                 {showFullContent ? 'Read Less' : 'Read More'}
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default ChapterDetails

// import { useState } from 'react'
// import { useNavigate, useParams, useLocation } from 'react-router-dom'
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
// import Navbar from './Navbar'

// const ChapterDetails = () => {
//   const navigate = useNavigate()
//   const { id } = useParams()
//   const location = useLocation()
//   const chapter = location.state?.chapter
//   console.log(chapter)
//   const previewLength = 500

//   const [showFullContent, setShowFullContent] = useState(false)
//   const content = chapter?.content || 'No content available.'

//   const toggleContent = () => setShowFullContent(!showFullContent)
//   const handleBack = () => navigate(-1)
//   const handleNext = () => navigate(+1)

//   return (
//     <>
//       <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//         {' '}
//         <Navbar />
//         <div className='container-fluid py-2'>
//           <div className='row'>
//             <div className='col-md-8 offset-md-2'>
//               {/* Navigation buttons */}
//               <div className='d-flex justify-content-between mb-4'>
//                 {/* <button
//                 className='btn text-primary border-0 d-inline-flex align-items-center'
//                 onClick={handleBack}
//               >
//                 <FaArrowLeft className='me-2' /> Back
//               </button> */}
//                 {/* <div>
//                 <a href='#' className='text-decoration-none me-3'>
//                   Chapters
//                 </a>
//                 <button
//                   className='btn text-primary border-0 d-inline-flex align-items-center'
//                   onClick={handleNext}
//                 >
//                   Next <FaArrowRight className='ms-2' />
//                 </button>
//               </div> */}
//               </div>

//               {/* Chapter header */}
//               <div className='mb-4'>
//                 <div className='d-flex align-items-baseline'>
//                   <h1
//                     style={{
//                       fontSize: '3.5rem',
//                       fontWeight: '700',
//                       marginRight: '1rem',
//                     }}
//                   >
//                     {chapter?.chapter_number}{' '}
//                     <div
//                       style={{
//                         backgroundColor: '#28a745',
//                         height: '6px',
//                         width: '150px',
//                         display: 'inline-block',
//                         marginBottom: '10px',
//                       }}
//                     ></div>
//                   </h1>
//                 </div>
//                 <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
//                   {chapter?.chapter_name || 'Academic Pressures'}
//                 </h2>
//               </div>

//               {/* Chapter content */}
//               <div className='mb-5'>
//                 <div
//                   className='p-0 rounded-3'
//                   onCopy={(e) => e.preventDefault()}
//                 >
//                   <div
//                     className='mb-3'
//                     style={{
//                       textAlign: 'justify',
//                       userSelect: 'none',
//                       // fontSize: '1rem',
//                       lineHeight: '1.6',
//                     }}
//                     dangerouslySetInnerHTML={{
//                       __html: showFullContent
//                         ? formatContent(content)
//                         : `${formatContent(
//                             content.substring(0, previewLength)
//                           )}...`,
//                     }}
//                   />
//                   {content.length > previewLength && (
//                     <button
//                       className='btn btn-link text-primary p-0'
//                       onClick={toggleContent}
//                       style={{ textDecoration: 'none' }}
//                     >
//                       {showFullContent ? 'Read Less' : 'Read More'}
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// // Helper function to format content with numbered sections and styling
// const formatContent = (content) => {
//   // For now, just returning HTML content as is.
//   // You could use a parser for markdown or custom formatting if needed.
//   return content
// }

// export default ChapterDetails

// import { useState } from 'react'
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
// import { useNavigate, useParams, useLocation } from 'react-router-dom'
// import Navbar from './Navbar'

// const ChapterDetails = () => {
//   const navigate = useNavigate()
//   const { id } = useParams()
//   const location = useLocation()
//   const chapter = location.state?.chapter
//   console.log(chapter)

//   const content = chapter?.content || 'No content available.'

//   const handleBack = () => navigate(-1)
//   const handleNext = () => navigate(+1)

//   return (
//     <>
//       <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//         <Navbar />
//         <div className='container-fluid py-2'>
//           <div className='row'>
//             <div className='col-md-8 offset-md-2'>
//               {/* Chapter header */}
//               <div className='mb-4'>
//                 <div className='d-flex align-items-baseline'>
//                   <h1
//                     style={{
//                       fontSize: '3.5rem',
//                       fontWeight: '700',
//                       marginRight: '1rem',
//                     }}
//                   >
//                     {chapter?.chapter_number}
//                     <div
//                       style={{
//                         backgroundColor: '#28a745',
//                         height: '6px',
//                         width: '150px',
//                         display: 'inline-block',
//                         marginBottom: '10px',
//                       }}
//                     ></div>
//                   </h1>
//                 </div>
//                 <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
//                   {chapter?.chapter_name || 'Academic Pressures'}
//                 </h2>
//               </div>

//               {/* Chapter content */}
//               <div className='mb-5'>
//                 <div
//                   className='p-0 rounded-3'
//                   onCopy={(e) => e.preventDefault()}
//                 >
//                   <div
//                     className='mb-3'
//                     style={{
//                       textAlign: 'justify',
//                       userSelect: 'none',
//                       lineHeight: '1.6',
//                     }}
//                     dangerouslySetInnerHTML={{
//                       __html: formatContent(content),
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// // Helper function to format content
// const formatContent = (content) => {
//   return content
// }

// export default ChapterDetails

// import { useState, useMemo } from 'react'
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
// import { useNavigate, useParams, useLocation } from 'react-router-dom'
// import Navbar from './Navbar'

// const ChapterDetails = () => {
//   const navigate = useNavigate()
//   const { id } = useParams()
//   const location = useLocation()
//   const chapter = location.state?.chapter
//   const content = chapter?.content || 'No content available.'

//   const [currentPage, setCurrentPage] = useState(0)

//   // Split HTML content by <p>, <br>, or other HTML blocks
//   const pages = useMemo(() => {
//     // Split based on paragraph or block-level tags
//     const segments = content.split(/<br\s*\/?>/i).filter(Boolean)
//     const chunkSize = 45 // Number of blocks per page
//     const paginated = []

//     for (let i = 0; i < segments.length; i += chunkSize) {
//       const pageContent = segments
//         .slice(i, i + chunkSize)
//         .map((s) => s.trim())
//         .map((s) => (s.endsWith('</p>') ? s : s + '</p>'))
//         .join('')
//       paginated.push(pageContent)
//     }

//     return paginated
//   }, [content])

//   const handlePrevPage = () => {
//     if (currentPage > 0) setCurrentPage(currentPage - 1)
//   }

//   const handleNextPage = () => {
//     if (currentPage < pages.length - 1) setCurrentPage(currentPage + 1)
//   }

//   return (
//     <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//       <Navbar />
//       <div className='container-fluid py-2'>
//         <div className='row'>
//           <div className='col-md-8 offset-md-2'>
//             {/* Header */}
//             <div className='mb-4'>
//               <div className='d-flex align-items-baseline'>
//                 <h1
//                   style={{
//                     fontSize: '3.5rem',
//                     fontWeight: '700',
//                     marginRight: '1rem',
//                   }}
//                 >
//                   {chapter?.chapter_number}
//                   <div
//                     style={{
//                       backgroundColor: '#28a745',
//                       height: '6px',
//                       width: '150px',
//                       display: 'inline-block',
//                       marginBottom: '10px',
//                     }}
//                   ></div>
//                 </h1>
//               </div>
//               <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
//                 {chapter?.chapter_name}
//               </h2>
//               <div className='d-flex justify-content-end'>
//                 {currentPage > 0 ? (
//                   <span
//                     role='button'
//                     onClick={handlePrevPage}
//                     className='text-primary'
//                     style={{ cursor: 'pointer', marginRight: '20px' }}
//                   >
//                     Previous
//                   </span>
//                 ) : (
//                   <span></span> // Empty span to keep spacing consistent
//                 )}

//                 <span className='align-self-center'>
//                   Page {currentPage + 1} of {pages.length}
//                 </span>

//                 {/* Show "Next" only if not on the last page */}
//                 {currentPage < pages.length - 1 ? (
//                   <span
//                     role='button'
//                     onClick={handleNextPage}
//                     className='text-primary'
//                     style={{ cursor: 'pointer', marginLeft: '20px' }}
//                   >
//                     Next
//                   </span>
//                 ) : (
//                   <span></span> // Empty span to keep spacing consistent
//                 )}
//               </div>
//             </div>

//             {/* Chapter content */}
//             <div className='mb-5'>
//               <div className='p-0 rounded-3' onCopy={(e) => e.preventDefault()}>
//                 <div
//                   className='mb-3'
//                   style={{
//                     textAlign: 'justify',
//                     userSelect: 'none',
//                     lineHeight: '1.6',
//                   }}
//                   dangerouslySetInnerHTML={{
//                     __html: pages[currentPage],
//                   }}
//                 />
//               </div>
//             </div>

//             {/* Pagination */}
//             {/* <div className='d-flex justify-content-between'>
//               <button
//                 className='btn btn-outline-primary'
//                 onClick={handlePrevPage}
//                 disabled={currentPage === 0}
//               >
//                 <FaArrowLeft /> Previous
//               </button>
//               <span className='align-self-center'>
//                 Page {currentPage + 1} of {pages.length}
//               </span>
//               <button
//                 className='btn btn-outline-primary'
//                 onClick={handleNextPage}
//                 disabled={currentPage === pages.length - 1}
//               >
//                 Next <FaArrowRight />
//               </button>
//             </div> */}
//             <div className='d-flex justify-content-center mb-3'>
//               {/* Show "Previous" only if not on the first page */}
//               {currentPage > 0 ? (
//                 <span
//                   role='button'
//                   onClick={handlePrevPage}
//                   className='text-primary'
//                   style={{ cursor: 'pointer', marginRight: '20px' }}
//                 >
//                   Previous
//                 </span>
//               ) : (
//                 <span></span> // Empty span to keep spacing consistent
//               )}

//               <span className='align-self-center'>
//                 Page {currentPage + 1} of {pages.length}
//               </span>

//               {/* Show "Next" only if not on the last page */}
//               {currentPage < pages.length - 1 ? (
//                 <span
//                   role='button'
//                   onClick={handleNextPage}
//                   className='text-primary'
//                   style={{ cursor: 'pointer', marginLeft: '20px' }}
//                 >
//                   Next
//                 </span>
//               ) : (
//                 <span></span> // Empty span to keep spacing consistent
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default ChapterDetails

// import { useEffect, useMemo, useState } from 'react'
// import { useLocation, useNavigate, useParams } from 'react-router-dom'
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
// import Navbar from './Navbar'

// const ChapterDetails = () => {
//    const navigate = useNavigate()
//    const { id } = useParams()
//    const location = useLocation()
//    const chapter = location.state?.chapter
//    const content = chapter?.content || 'No content available.'

//    const [currentPage, setCurrentPage] = useState(0)

//   const pages = useMemo(() => {
//     const segments = content
//       .split(/<br\s*\/?>/i)
//       .map((s) => s.trim())
//       .filter(Boolean)

//     const numberedSectionRegex = /^\d+\.\s/
//     const groupedSections = []
//     let currentSection = ''

//     // Step 1: Group paragraphs based on numbered headings
//     segments.forEach((segment) => {
//       const plainText = segment.replace(/<[^>]*>/g, '')
//       const isNumbered = numberedSectionRegex.test(plainText)

//       if (isNumbered && currentSection !== '') {
//         groupedSections.push(currentSection)
//         currentSection = segment + '<br/>'
//       } else {
//         currentSection += segment + '<br/>'
//       }
//     })

//     if (currentSection) groupedSections.push(currentSection)

//     // Step 2: Group 4–5 numbered sections per page
//     const finalPages = []
//     const sectionPerPage = 8 // Or 5, depending on spacing

//     for (let i = 0; i < groupedSections.length; i += sectionPerPage) {
//       const chunk = groupedSections.slice(i, i + sectionPerPage).join('')
//       finalPages.push(chunk)
//     }

//     return finalPages
//   }, [content])

//    useEffect(() => {
//      window.scrollTo({ top: 0, behavior: 'smooth' })
//    }, [currentPage])

//   const handlePrevPage = () => {
//     if (currentPage > 0) setCurrentPage(currentPage - 1)
//   }

//   const handleNextPage = () => {
//     if (currentPage < pages.length - 1) setCurrentPage(currentPage + 1)
//   }

//   return (
//     <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
//       <Navbar />
//       <div className='container-fluid py-2'>
//         <div className='row'>
//           <div className='col-md-8 offset-md-2'>
//             {/* Header */}
//             <div className='mb-4'>
//               <div className='d-flex align-items-baseline'>
//                 <h1
//                   style={{
//                     fontSize: '3.5rem',
//                     fontWeight: '700',
//                     marginRight: '1rem',
//                   }}
//                 >
//                   {chapter?.chapter_number}
//                   <div
//                     style={{
//                       backgroundColor: '#28a745',
//                       height: '6px',
//                       width: '150px',
//                       display: 'inline-block',
//                       marginBottom: '10px',
//                     }}
//                   ></div>
//                 </h1>
//               </div>
//               <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
//                 {chapter?.chapter_name}
//               </h2>
//               <div className='d-flex justify-content-end'>
//                 {currentPage > 0 ? (
//                   <span
//                     role='button'
//                     onClick={handlePrevPage}
//                     className='text-primary'
//                     style={{ cursor: 'pointer', marginRight: '20px' }}
//                   >
//                     Previous
//                   </span>
//                 ) : (
//                   <span></span> // Empty span to keep spacing consistent
//                 )}

//                 <span className='align-self-center'>
//                   Page {currentPage + 1} of {pages.length}
//                 </span>

//                 {/* Show "Next" only if not on the last page */}
//                 {currentPage < pages.length - 1 ? (
//                   <span
//                     role='button'
//                     onClick={handleNextPage}
//                     className='text-primary'
//                     style={{ cursor: 'pointer', marginLeft: '20px' }}
//                   >
//                     Next
//                   </span>
//                 ) : (
//                   <span></span> // Empty span to keep spacing consistent
//                 )}
//               </div>
//             </div>

//             {/* Chapter content */}
//             <div className='mb-5'>
//               <div className='p-0 rounded-3' onCopy={(e) => e.preventDefault()}>
//                 <div
//                   className='mb-3'
//                   style={{
//                     textAlign: 'justify',
//                     userSelect: 'none',
//                     lineHeight: '1.6',
//                   }}
//                   dangerouslySetInnerHTML={{
//                     __html: pages[currentPage],
//                   }}
//                 />
//               </div>
//             </div>

//             {/* Pagination */}
//             {/* <div className='d-flex justify-content-between'>
//               <button
//                 className='btn btn-outline-primary'
//                 onClick={handlePrevPage}
//                 disabled={currentPage === 0}
//               >
//                 <FaArrowLeft /> Previous
//               </button>
//               <span className='align-self-center'>
//                 Page {currentPage + 1} of {pages.length}
//               </span>
//               <button
//                 className='btn btn-outline-primary'
//                 onClick={handleNextPage}
//                 disabled={currentPage === pages.length - 1}
//               >
//                 Next <FaArrowRight />
//               </button>
//             </div> */}
//             <div className='d-flex justify-content-center mb-3'>
//               {/* Show "Previous" only if not on the first page */}
//               {currentPage > 0 ? (
//                 <span
//                   role='button'
//                   onClick={handlePrevPage}
//                   className='text-primary'
//                   style={{ cursor: 'pointer', marginRight: '20px' }}
//                 >
//                   Previous
//                 </span>
//               ) : (
//                 <span></span> // Empty span to keep spacing consistent
//               )}

//               <span className='align-self-center'>
//                 Page {currentPage + 1} of {pages.length}
//               </span>

//               {/* Show "Next" only if not on the last page */}
//               {currentPage < pages.length - 1 ? (
//                 <span
//                   role='button'
//                   onClick={handleNextPage}
//                   className='text-primary'
//                   style={{ cursor: 'pointer', marginLeft: '20px' }}
//                 >
//                   Next
//                 </span>
//               ) : (
//                 <span></span> // Empty span to keep spacing consistent
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default ChapterDetails

import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import Navbar from './Navbar'
import axios from 'axios'

const ChapterDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()
  const chapter = location.state?.chapter
  const content = chapter?.content || 'No content available.'
  const [chapterData, setChapterData] = useState(null)
  const [loading, setLoading] = useState(true)

  const [currentPage, setCurrentPage] = useState(0)

  useEffect(() => {
    const fetchChapterContent = async () => {
      try {
        const { data } = await axios.get(
          `https://aimuseumbackend.teslabird.com/membership/chapter-content/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access')}`,
              'Content-Type': 'application/json',
            },
          }
        )
        setChapterData(data)
      } catch (error) {
        console.error('Failed to fetch chapter content:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchChapterContent()
  }, [id])

  const pages = useMemo(() => {
    const content = chapterData?.content || 'No content available.'
    const segments = content
      .split(/<br\s*\/?>/i)
      .map((s) => s.trim())
      .filter(Boolean)

    const numberedSectionRegex = /^\d+\.\s/
    const groupedSections = []
    let currentSection = ''

    segments.forEach((segment) => {
      const plainText = segment.replace(/<[^>]*>/g, '')
      const isNumbered = numberedSectionRegex.test(plainText)

      if (isNumbered && currentSection !== '') {
        groupedSections.push(currentSection)
        currentSection = segment + '<br/>'
      } else {
        currentSection += segment + '<br/>'
      }
    })

    if (currentSection) groupedSections.push(currentSection)

    const sectionPerPage = 9
    const finalPages = []

    for (let i = 0; i < groupedSections.length; i += sectionPerPage) {
      const chunk = groupedSections.slice(i, i + sectionPerPage).join('')
      finalPages.push(chunk)
    }

    return finalPages
  }, [chapterData])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [currentPage])

  const handlePrevPage = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1)
  }

  const handleNextPage = () => {
    if (currentPage < pages.length - 1) setCurrentPage(currentPage + 1)
  }

  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      <Navbar />
      <div className='container-fluid py-2'>
        <div className='row'>
          <div className='col-md-8 offset-md-2'>
            {/* Header */}
            <div className='mb-4'>
              <div className='d-flex align-items-baseline'>
                <h1
                  style={{
                    fontSize: '3.5rem',
                    fontWeight: '700',
                    marginRight: '1rem',
                  }}
                >
                  {chapter?.chapter_number}
                  <div
                    style={{
                      backgroundColor: '#28a745',
                      height: '6px',
                      width: '150px',
                      display: 'inline-block',
                      marginBottom: '10px',
                    }}
                  ></div>
                </h1>
              </div>
              <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
                {chapterData?.chapter_name || 'Chapter'}
              </h2>
              <div className='d-flex justify-content-end'>
                {currentPage > 0 ? (
                  <span
                    role='button'
                    onClick={handlePrevPage}
                    className='text-primary'
                    style={{ cursor: 'pointer', marginRight: '20px' }}
                  >
                    Previous
                  </span>
                ) : (
                  <span></span> // Empty span to keep spacing consistent
                )}

                <span className='align-self-center'>
                  Page {currentPage + 1} of {pages.length}
                </span>

                {/* Show "Next" only if not on the last page */}
                {currentPage < pages.length - 1 ? (
                  <span
                    role='button'
                    onClick={handleNextPage}
                    className='text-primary'
                    style={{ cursor: 'pointer', marginLeft: '20px' }}
                  >
                    Next
                  </span>
                ) : (
                  <span></span> // Empty span to keep spacing consistent
                )}
              </div>
            </div>

            {/* Chapter content */}
            {loading ? (
              <div className='text-center'>
                <div className='spinner-border text-primary' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {' '}
                <div className='mb-5'>
                  <div
                    className='p-0 rounded-3'
                    onCopy={(e) => e.preventDefault()}
                  >
                    <div
                      className='mb-3'
                      style={{
                        textAlign: 'justify',
                        userSelect: 'none',
                        lineHeight: '1.6',
                      }}
                      dangerouslySetInnerHTML={{
                        __html: pages[currentPage],
                      }}
                    />
                  </div>
                </div>
              </>
            )}

            <div className='d-flex justify-content-center mb-3'>
              {currentPage > 0 ? (
                <span
                  role='button'
                  onClick={handlePrevPage}
                  className='text-primary'
                  style={{ cursor: 'pointer', marginRight: '20px' }}
                >
                  Previous
                </span>
              ) : (
                <span></span>
              )}

              <span className='align-self-center'>
                Page {currentPage + 1} of {pages.length}
              </span>

              {currentPage < pages.length - 1 ? (
                <span
                  role='button'
                  onClick={handleNextPage}
                  className='text-primary'
                  style={{ cursor: 'pointer', marginLeft: '20px' }}
                >
                  Next
                </span>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChapterDetails
